export default __webpack_public_path__ + "static/media/POPPINS-SEMIBOLD.e67a02ce.TTF";